import React, { } from 'react'
import VincularAoProjeto from './VincularAoProjeto'

const StepVincularAoProjeto = () => {


    return (
        <>
            <VincularAoProjeto />
        </>
    )
}

export default StepVincularAoProjeto